/**
 * Ported from wear/src/main/java/com/example/myrangefinder/data/location/LocationProvider.kt.
 *
 * Coordinate order is (longitude, latitude) — the same as GeoJSON and Mongo, and the
 * reverse of what most JS mapping libraries expect. Keeping the watch's convention means
 * the two codebases stay diff-able; flipping it here would guarantee a silent bug the
 * first time someone copies a formula across.
 */

export interface GeoPoint {
  longitude: number;
  latitude: number;
}

export function geoPoint(longitude: number, latitude: number): GeoPoint {
  return { longitude, latitude };
}

/** Builds a GeoPoint from a GeoJSON coordinate pair, which is already [lng, lat]. */
export function fromCoordinates(coords: [number, number]): GeoPoint {
  return { longitude: coords[0], latitude: coords[1] };
}

const EARTH_RADIUS_M = 6_371_000;

const toRad = (deg: number): number => (deg * Math.PI) / 180;

/** Great-circle distance in metres. Same radius constant as the watch, so both agree. */
export function haversineMeters(a: GeoPoint, b: GeoPoint): number {
  const dLat = toRad(b.latitude - a.latitude);
  const dLng = toRad(b.longitude - a.longitude);
  const sinDLat = Math.sin(dLat / 2);
  const sinDLng = Math.sin(dLng / 2);
  const h =
    sinDLat * sinDLat +
    Math.cos(toRad(a.latitude)) * Math.cos(toRad(b.latitude)) * sinDLng * sinDLng;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(h)));
}
